<h2 mat-dialog-title>Set persona</h2>

<mat-dialog-content class="dialog-content">
  <p class="dialog-message">You can choose the desired personas for the current workspace here</p>

  <app-persona-selector
      [initialSelectedPersonaIds]="selectedPersonaIds"
      [disabled]="isPersonaSaving"
      (selectionChange)="onSelectionChange($event)">
  </app-persona-selector>

</mat-dialog-content>

<mat-dialog-actions [align]="'end'">
  <button mat-button [disabled]="isPersonaSaving" (click)="onCancel()">Cancel</button>
  <app-loader-button class="save-button" mat-flat-button [loading]="isPersonaSaving" color="primary" (click)="onConfirm()"
    >Confirm</app-loader-button
  >
</mat-dialog-actions>
